<template>
  <v-app>
    <AppNavigation></AppNavigation>
    <v-content transition="slide-x-transition">
      <router-view id="router-container"></router-view>
      <FabSpeedDial></FabSpeedDial>
    </v-content>

    <AppFooter></AppFooter>
  </v-app>
</template>
<script>
import AppNavigation from '@/components/common/AppNavigation.vue'
import AppFooter from '@/components/common/AppFooter.vue'
import FabSpeedDial from '@/components/ui/FabSpeedDial.vue'
export default {
    name: 'App',
    components: {
      AppNavigation,
      AppFooter,
      FabSpeedDial
    },
    beforeMount() {
        for (var prop1 in assetsDestinationsDirectory) {
            for (var prop2 in this.$store.state.destinations) {
                if (prop1 == prop2.toLowerCase()) {
                    this.$store.state.destinations[prop2].pics = assetsDestinationsDirectory[prop1]
                }
            }
        }

    }
};
</script>

<style lang="scss">
.v-content__wrap {
    position: static !important;
}
#router-container {
    position: none;
    z-index: -1;
    background: white;
    overflow: hidden;
    background-repeat: no-repeat;
    width: 100%;
    height: 100%;
    background-size: cover;
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 1), rgba(255, 255, 255, 0)), url('./assets/backgrounds/about.jpg');
}
</style>
